/**
 * Decorates a property accessor to memoize its return value.
 */
export function memoized(_target, propertyName, descriptor) {
    if (!descriptor || typeof descriptor.get !== "function") {
        throw new Error("@memoized decorator can only be applied to getters");
    }
    const originalGet = descriptor.get;
    const memoSymbol = Symbol(`__memoized_${propertyName}`);
    descriptor.get = function () {
        if (!this.hasOwnProperty(memoSymbol)) {
            Object.defineProperty(this, memoSymbol, {
                configurable: false,
                enumerable: false,
                writable: true,
                value: originalGet.apply(this),
            });
        }
        return this[memoSymbol];
    };
}
//# sourceMappingURL=decorators.js.map